import React, { Component } from 'react';

import '@/companys/ttl/assets/styles/components/instrument/market-set-confirm-dialog.scss'
import { connect } from 'react-redux';

class MarketSetconfirmDialog extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}
	render() {
		const { language,content ,theme } = this.props
		return (
			<div className='market-confirm-dialog'>
				<div className='confirm-text' >{content } </div>
				<div className='market-confirm-button'>
					<div className='cancel-button' style={{color:theme==='light'?'#fff':''}} onClick={()=>this.props.onClose()} >{language.common_cancel}</div>
					<div className='confirm-button' style={{color:theme==='light'?'#fff':''}}  onClick={()=>this.handleConfirm()} >{language.common_confirm}</div>
				</div>
			</div>
		)
	}
	handleConfirm(){
		this.props.fun()
		this.props.onClose()
	}
}

export default connect(state => ({
	language: state.app.language,
	theme: state.app.theme,
}),
	dispatch => ({

	}))(MarketSetconfirmDialog)